import { render, staticRenderFns } from "./customfield-add-modal.vue?vue&type=template&id=b112c0c6&scoped=true"
import script from "./customfield-add-modal.vue?vue&type=script&lang=js"
export * from "./customfield-add-modal.vue?vue&type=script&lang=js"
import style0 from "./customfield-add-modal.vue?vue&type=style&index=0&id=b112c0c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b112c0c6",
  null
  
)

export default component.exports